module.exports = "/static/assets/ab1aa02438c4970ec7010ef055a6695c.png";